<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="bap_vendname"
      placeholder="输入供应商进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/money/pay_billap/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.bap_vendname}}</p>
          <p class="list-item-muted">{{item.bap_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.bap_amount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.bap_status!='已审核'}"
          >{{item.bap_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('bap_amount')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    
    return {
      listUrl: "/api/money/billap/list",
      filters: [
        {
          type: "date",
          name: "bap_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          // beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "已付款",
              condition: "ifnull(bap_billstatus,' ')='已付款'",
            },
            {
              value: 2,
              label: "已退还",
              condition: "ifnull(bap_billstatus,' ')='已退还'",
            },
            {
              value: 3,
              label: "到期预警",
              condition: "bap_statuscode='AUDITED' AND bap_duedate-CURRENT_DATE<=7 and ifnull(bap_billstatus,' ')=' ' ",
            },
          ]
        }
      ]
    };
  },
  
};
</script>